export default __webpack_public_path__ + "static/media/chatIconHCSelected.526d3e2f.svg";